"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var portal_1 = require("./portal");
var position_1 = require("./position");
var root_close_wrapper_1 = require("./root-close-wrapper");
var react_prop_types_1 = require("../react-prop-types");
/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var BaseOverlay = /** @class */ (function (_super) {
    __extends(BaseOverlay, _super);
    function BaseOverlay(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onHiddenListener = function (node) {
            _this.setState({
                exited: true
            });
            if (_this.props.onExited) {
                _this.props.onExited(node);
            }
        };
        _this.state = {
            exited: !props.show
        };
        return _this;
    }
    BaseOverlay.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.show) {
            this.setState({ exited: false });
        }
        else if (!nextProps.transition) {
            // Otherwise let onHiddenListener take care of marking exited.
            this.setState({
                exited: true
            });
        }
    };
    BaseOverlay.prototype.render = function () {
        var _a = this.props, container = _a.container, containerPadding = _a.containerPadding, target = _a.target, placement = _a.placement, shouldUpdatePosition = _a.shouldUpdatePosition, rootClose = _a.rootClose, children = _a.children, show = _a.show, onHide = _a.onHide, Transition = _a.transition;
        // Don't un-render the overlay while it's transitioning out.
        var mountOverlay = show || (Transition && !this.state.exited);
        if (!mountOverlay) {
            // Don't bother showing anything if we don't have to.
            return null;
        }
        var child = children;
        // Position is be inner-most because it adds inline styles into the child,
        // which the other wrappers don't forward correctly.
        child = (React.createElement(position_1.Position, __assign({}, { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition }), child));
        if (Transition) {
            var _b = this.props, onExit = _b.onExit, onExiting = _b.onExiting, onEnter = _b.onEnter, onEntering = _b.onEntering, onEntered = _b.onEntered;
            // This animates the child node by injecting props, so it must precede
            // anything that adds a wrapping div.
            child = (React.createElement(Transition, { in: show, transitionAppear: true, onExit: onExit, onExiting: onExiting, onExited: this.onHiddenListener, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered }, child));
        }
        // This goes after everything else because it adds a wrapping div.
        if (rootClose) {
            child = (React.createElement(root_close_wrapper_1.RootCloseWrapper, { onRootClose: onHide }, child));
        }
        return (React.createElement(portal_1.Portal, { container: container }, child));
    };
    BaseOverlay.propTypes = Object.assign({}, portal_1.Portal.propTypes, position_1.Position.propTypes, {
        show: PropTypes.bool,
        rootClose: PropTypes.bool,
        onHide: function (props, key, componentName) {
            var rest = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                rest[_i - 3] = arguments[_i];
            }
            var propType = PropTypes.func;
            if (props.rootClose) {
                propType = propType.isRequired;
            }
            return propType.apply(void 0, __spreadArrays([props, key, componentName], rest));
        },
        transition: react_prop_types_1.elementType,
        onEnter: PropTypes.func,
        onEntering: PropTypes.func,
        onEntered: PropTypes.func,
        onExit: PropTypes.func,
        onExiting: PropTypes.func,
        onExited: PropTypes.func
    });
    return BaseOverlay;
}(React.Component));
exports.BaseOverlay = BaseOverlay;
